import { getOperatorNameOrEmail } from "utils/Operator"
import { editorMentions, messageMentions, spanWithId } from "./constants"
import { usersHelpers } from "utils"

export const setFormatMessagesMentions = (text, mentions, _id='') => {
  let newText = usersHelpers.showLinkMessages(text)
  if (mentions){
    const { usersInfo } = mentions
    newText = newText.replace(messageMentions, (match, id) => {
      let names
      let userOperator
      if(usersInfo) {
        userOperator = usersInfo.find(user => user._id === id)
        const { name, lastname, email } = userOperator
        names = getOperatorNameOrEmail({ name, surname: lastname, email })
      } else {
        names = id
      }
      return `<span data-mention-id="${id}" class='inchat-message__text--mentions mention-span-message-${_id}'>@${names}</span>`
    })
  }
  return newText
}

export const setFormatEditorMentions = (text, mentions) => {
  let newText = text
  if (mentions && mentions.length){
    newText = newText.replace(editorMentions, (match, id) => {
      let names
      if(mentions) {
        const { name, lastname, email } = mentions.find(user => user._id === id)
        names = getOperatorNameOrEmail({ name, surname: lastname, email })
      }
      return `<span id="${id}" style="color: #6411db; font-size: 13px; font-weight: 600; letter-spacing: 0; line-height: normal;">@${names}</span>&nbsp;`
    })
  }
  return newText
}

export const addBrackets = (text) => {
  const result = text.replace(spanWithId, '<@$1>')
  return result
}

export const removeBrackets = (text) => {
  const result = text.replace(messageMentions, '@$1')
  return result
}

export const verifyIdIncomplete = (texto, mentions) => {
  const replacedText = texto.replace(spanWithId, (match, id, content) => {
    let names
    if(mentions) {
      const { name, lastname, email } = mentions.find(user => user._id === id)
      names = `@${getOperatorNameOrEmail({ name, surname: lastname, email })}`
    }
    if(names === content){
      return match
    }
    return '@'
  })
  return replacedText.replace(/@&nbsp;/g, '@ ')
}

// detecta la ultima palabra de escrita inicie con @
export const detectLastWord = (text) => {
  let words = text.replace('&nbsp;', ' ')
  words = words.split(' ')
  const lastWord = words[words.length - 1]
  return { isShow: lastWord.startsWith('@'), lastWord: lastWord.replace('&nbsp;', '') }
}

export const removeHTML = (text) => {
  var regularExpression = /<[^>]*>/g
  return text.replace(regularExpression, '')
}

export const validateDeactivatedUsers = (conversationInfo, operatorId) => {
  if(Object.entries(conversationInfo).length === 0) return false
  if(conversationInfo.type === 'channel') return false
  const usersInfo = conversationInfo?.usersInfo || []
  if(usersInfo.length === 0) return false
  const newUsersInfo = usersInfo.filter((user) => user._id !== operatorId)
  for (let i = 0; i < newUsersInfo.length; i++) {
    if(newUsersInfo[i].isActive) return false
  }
  return true
}

export const validateOneDeactivatedUser = (usersInfo) => {
  if(usersInfo.length === 0) return false
  return usersInfo.some(user => !user.isActive)
}